<!--  -->
<template>
  <div>
    <!-- <div class="optionbox">
      <div class="optiontext">章节：</div>
      <el-input v-model="fromAge" type="number" style="width:400px" placeholder="请输入章节(只能输入1-8)" />
    </div> -->
    <div class="optionbox">
      <div class="optiontext">推广链接名称：</div>
      <el-input
        v-model="link_name"
        style="width:400px"
        placeholder="请输入推广链接名称(只能输入汉字、字母、数字和中划线)"
        :change="check_num()"
      />
    </div>
    <div class="optionbox">
      <div class="optiontext">推广类型：</div>
      <el-radio-group v-model="linktyperadio">
        <el-radio :label="1">内推</el-radio>
        <el-radio :label="0">外推</el-radio>
      </el-radio-group>
    </div>
    <div class="optionbox">
      <div class="optiontext">推广渠道：</div>
      <el-select
        v-model="media_type"
        placeholder="请选择"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
    </div>
    <div class="optionbox">
      <div class="optiontext">强关设置：</div>
      <el-radio-group v-model="follow_type">
        <el-radio :label="1">强制关注</el-radio>
        <el-radio :label="2">主动关注</el-radio>
        <el-radio :label="3">不设置强关</el-radio>
      </el-radio-group>
    </div>
    <div
      v-if="follow_type!=3"
      class="optionbox"
    >
      <div class="optiontext">强关章节：</div>
      <el-tag
        v-if="follow_name!=''"
        style="margin-right:10px"
      >{{ follow_name }}</el-tag>
      <el-button
        type="primary"
        size="mini"
        :disabled="objquery.bookid==null"
        @click="chapterclick"
      >选择章节</el-button>
    </div>
    <el-button
      type="primary"
      @click="sumbit"
    >确定</el-button>

    <el-dialog
      title="选择章节"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="chapterdialogVisibler"
      :destroy-on-close="true"
    >
      <chapterdialog
        ref="chapterviewr"
        @chaptercallback="chaptercallback"
      />
    </el-dialog>
  </div>
</template>

<script>
import { bookPlatformcreate } from '@/api/sourceMaterial.js'
import chapterdialog from './chapterdialog.vue'
export default {
  components: { chapterdialog },
  props: {
    obj: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      objquery: {},
      fromAge: '',
      link_name: '',
      linktyperadio: 1,
      media_type: null,
      follow_type: 3,
      follow_name: '',
      follow_sort: null,
      follow_id: null,
      chapterdialogVisibler: false,
      options: [
        {
          value: 1,
          label: 'MP'
        },
        {
          value: 2,
          label: '广点通'
        },
        {
          value: 3,
          label: '巨量引擎'
        },
        {
          value: 4,
          label: '快手'
        },
        {
          value: 5,
          label: '百度'
        },
        {
          value: 6,
          label: 'uc'
        },
        {
          value: 7,
          label: 'vivo'
        }
      ]
    }
  },
  watch: {
    fromAge(newName, oldName) {
      var reg = /^([1-9]\d|\d)$/
      if (!reg.test(newName)) {
        this.fromAge = ''
      } else {
        if (newName > 8) {
          this.fromAge = 8
          // eslint-disable-next-line eqeqeq
        } else if (newName == 0) {
          this.fromAge = 1
        } else {
          this.fromAge = newName
        }
      }
    },
    obj: {
      handler(newValue, oldValue) {
        // console.log('111', newValue)
        this.objquery = newValue
      },
      deep: true
    }
  },
  created() {
    this.objquery = this.obj
  },
  mounted() {},
  methods: {
    check_num: function() {
      this.link_name = this.link_name.replace(/[^\a-\z\A-\Z0-9\u4e00-\u9fe5-]/g, '')
    },
    async sumbit() {
      console.log('this.objquery', this.objquery)
      if (this.objquery.platformvalue === null) {
        this.$message.error('请选择平台')
        return
      }
      if (this.objquery.bookid === null) {
        this.$message.error('请选择书籍')
        return
      }
      if (this.objquery.chapterid === null) {
        this.$message.error('请选择章节')
        return
      }
      if (this.link_name === '') {
        this.$message.error('请输入推广链接名称')
        return
      }
      if (this.media_type === null) {
        this.$message.error('请选择推广渠道')
        return
      }
      if (this.follow_type !== 3 && this.follow_id === null) {
        this.$message.error('请选择强关章节')
        return
      }
      const par = {}
      if (this.follow_type !== 3) {
        par.follow_id = this.follow_id
        par.follow_sort = this.follow_sort
        par.follow_name = this.follow_name
      }
      const data = await bookPlatformcreate({
        platform_id: this.objquery.platformvalue,
        template_data: {
          content_id: this.objquery.bookid,
          item_id: this.objquery.chapterid,
          // chapter_idx: this.objquery.chapteridx,
          chapter_name: this.objquery.chaptername,
          // index: this.fromAge,
          link_name: this.link_name,
          link_type: this.linktyperadio,
          media_type: this.media_type,
          follow_type: this.follow_type,
          ...par
        }
      })
      console.log('data', data)
      this.$emit('close')
      this.$message({
        message: '添加成功',
        type: 'success'
      })
    },
    chapterclick() {
      this.chapterdialogVisibler = true
      this.$nextTick(() => {
        this.$refs.chapterviewr.send(this.objquery.platformvalue, this.objquery.bookids)
      })
    },
    chaptercallback(val) {
      console.log('val1', val)
      this.chapterdialogVisibler = false
      this.follow_name = val.chapter_name
      this.follow_id = val.chapter_id
      this.follow_sort = val.chapter_idx
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
/* @import url(); 引入css类 */
.optionbox {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.optiontext {
  width: 100px;
  text-align: right;
}
.loltext {
  margin-left: 100px;
}
.demo-ruleForm /deep/ .el-input__inner {
  line-height: 1px !important;
}
/**
 * 解决el-input设置类型为number时，去掉输入框后面上下箭头
 **/
.demo-ruleForm /deep/ input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
